/**
 * Equipment types constants
 */

export const EQUIPMENT_TYPES = {
  BARBELL: 'barbell',
  DUMBBELL: 'dumbbell',
  SMITH_MACHINE: 'smith_machine',
  CABLE: 'cable',
  MACHINE: 'machine',
  BAND: 'band',
  KETTLEBELL: 'kettlebell',
  BODYWEIGHT: 'bodyweight',
};

// UI display labels
export const EQUIPMENT_LABELS = {
  [EQUIPMENT_TYPES.BARBELL]: 'Barbell',
  [EQUIPMENT_TYPES.DUMBBELL]: 'Dumbbell',
  [EQUIPMENT_TYPES.SMITH_MACHINE]: 'Smith Machine',
  [EQUIPMENT_TYPES.CABLE]: 'Cable',
  [EQUIPMENT_TYPES.MACHINE]: 'Machine',
  [EQUIPMENT_TYPES.BAND]: 'Band',
  [EQUIPMENT_TYPES.KETTLEBELL]: 'Kettlebell',
  [EQUIPMENT_TYPES.BODYWEIGHT]: 'Bodyweight',
};

/**
 * Format equipment type for display
 * @param {string|null} equipmentType
 * @returns {string}
 */
export function formatEquipmentType(equipmentType) {
  if (!equipmentType) return '';
  return EQUIPMENT_LABELS[equipmentType] || equipmentType;
}

/**
 * Get display name for exercise (includes equipment type if present)
 * @param {string} name - Exercise name
 * @param {string|null} equipmentType - Equipment type
 * @returns {string}
 */
export function getExerciseDisplayName(name, equipmentType) {
  if (!equipmentType) return name;
  const label = formatEquipmentType(equipmentType);
  return `${name} (${label})`;
}
